module.exports = __webpack_public_path__ + "static/img/banner1920.0a62235.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/banner1920.jpg
// module id = g8El
// module chunks = 6